
<ion-content [hidden]="searchResultsEnable">

 <ion-refresher (ionRefresh)="doRefresh($event)">
    <ion-refresher-content
      pullingIcon="arrow-dropdown"
      pullingText="Pull to refresh"
      refreshingSpinner="crescent"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher> 
 

  <!-- <div>
      <scroll-tabs #scrollTab [tabs]="tabs" (onSelectedTab)="tabChange($event)"></scroll-tabs>
    </div> -->


  
  <ion-list class="accordion-list"  no-lines >

       
    <!-- First Level -->
    <ion-list-header *ngFor="let item of destinations; let i = index" no-lines no-padding>
      <!-- Toggle Button -->
      <button ion-item  class="margin" (click)="clickevent(item,i)" detail-none [ngClass]="{'section-active': item.open, 'section': !item.open}">
 <!--         <ion-icon item-left name="arrow-forward" color="dark" *ngIf="!item.open"></ion-icon>
        <ion-icon item-left name="arrow-down" color="dark" *ngIf="item.open"></ion-icon>  -->
        <ion-icon item-right name="add" large *ngIf="!item.open" color="dark" width="24px" height="24px"></ion-icon>
        <ion-icon item-right name="add" large *ngIf="item.open" color="dark" width="24px" height="24px"></ion-icon>
<!--       <img item-right src="{{ item.image }}" *ngIf="!item.open" width="24px" height="24px">
        <img item-right src="{{ item.image }}" *ngIf="item.open" width="24px" height="24px">  -->
        <p class="ws2"><b>{{ item.DestinationName }}</b></p>
      </button>
 
      <ion-list *ngIf="item.SubCategory && item.open" no-lines>
        <!-- Second Level -->
        <ion-list-header *ngFor="let child of item.SubCategory; let j = index" no-padding>
        
          <button ion-item (click)="toggleItem(i, j)" *ngIf="child.children" class="child" detail-none>
            <ion-icon item-left name="add" *ngIf="!child.open"></ion-icon>
            <ion-icon item-left name="close" *ngIf="child.open"></ion-icon>
            {{ child.SubCategoryName }}
          </button>

       
 
          <ion-list *ngIf="child.children && child.open">
            <!-- Third Level -->
            <ion-item *ngFor="let item of child.children; let k = index" detail-none class="child-item" text-wrap>
              <h2>{{ item.name }}</h2>
              <p text-lowercase>{{ item.information }}</p>
              <!-- Direct Add Button -->
              <button ion-button outline item-end (click)="buyItem(item)">{{ item.price }}</button>
            </ion-item>
          </ion-list>
        </ion-list-header>
      </ion-list>
      
    </ion-list-header>
  </ion-list>
       
</ion-content>
<ion-content  *ngIf="searchResultsEnable">
  <search-results-page [params]="searchparams"></search-results-page>
  
  </ion-content> 